import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '../../../visual-components/link/link';
import { TableCellDialog } from '../../../visual-components/table/table-cells/table-cell-dialog/table-cell-dialog';
import { Typography } from '../../../visual-components/typography/typography';

type Props = {
  articleId: string;
  handleConfirm: () => Promise<void>;
};

export const TableCellDeleteItemVisual: React.FC<Props> = ({ articleId, handleConfirm }) => {
  const { t } = useTranslation();

  return (
    <TableCellDialog
      childrenDialog={<Typography variant="maintext">{t('cart.removeArticle', { value: articleId })}</Typography>}
      handleClick={handleConfirm}
      titleDialog={t('cart.documentTitle')}
      triggerDialog={<LinkButton aria-label={t('a11y.removeArticle')} icon="trashcan" />}
    />
  );
};
